import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable no-console */
import React, { useMemo, useEffect, useRef, useCallback, useState } from 'react';
import { shallow } from 'zustand/shallow';
import { useViewConfigStoreApi, createLoaders, useViewConfig, useSetViewConfig, } from '@vitessce/vit-s';
import { Checkbox, Grid, } from '@vitessce/styles';
import { log } from '@vitessce/globals';
export default function LinkController(props) {
    const { linkIDInit, authToken, linkEndpoint, websocketEndpoint, fileTypes, coordinationTypes, stores, } = props;
    const viewConfigStoreApi = useViewConfigStoreApi();
    const viewConfig = useViewConfig();
    const setViewConfig = useSetViewConfig(viewConfigStoreApi);
    const [socketOpen, setSocketOpen] = useState(false);
    const [sync, setSync] = useState(true);
    const connection = useRef(null);
    const [linkID, setLinkID] = useState(null);
    const id = useMemo(() => `id_${Math.floor(Math.random() * 1000)}`, []);
    // Reference: https://github.com/pmndrs/zustand/tree/v3.7.2?tab=readme-ov-file#readingwriting-state-and-reacting-to-changes-outside-of-components
    const setConfig = useCallback((newConfig) => {
        viewConfigStoreApi.setState({
            viewConfig: newConfig,
            mostRecentConfigSource: 'external',
            loaders: createLoaders(newConfig.datasets, newConfig.description, fileTypes, coordinationTypes, stores),
        });
    }, [viewConfigStoreApi]);
    const onConfigChange = useCallback((configValue) => {
        if (sync && socketOpen) {
            try {
                const configString = `${id};${btoa(encodeURI(JSON.stringify(configValue)))}`;
                const message = {
                    action: 'sendMessage',
                    message: configString,
                };
                connection.current?.send(JSON.stringify(message));
            }
            catch (error) {
                log.error('Unable to send Configuration to Server', error);
            }
        }
    }, [id, socketOpen, sync]);
    useEffect(() => {
        if (linkIDInit != null) {
            setLinkID(linkIDInit);
        }
        else if (linkID === null) {
            fetch(linkEndpoint, {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                },
            }).then(response => response.json()).then((response) => {
                setLinkID(response.link_id);
                const newLayout = viewConfig.layout.map((viewDef) => {
                    if (viewDef.component === 'linkController') {
                        return {
                            ...viewDef,
                            props: {
                                ...(viewDef.props || {}),
                                linkID: response.link_id,
                            },
                        };
                    }
                    return viewDef;
                });
                const newViewConfig = {
                    ...viewConfig,
                    layout: newLayout,
                };
                setViewConfig(newViewConfig);
            }).catch((err) => {
                log.error('Fetch Error :-S', err);
            });
        }
    }, [linkID, linkEndpoint]);
    useEffect(() => viewConfigStoreApi.subscribe(state => ({
        viewConfig: state.viewConfig,
        mostRecentConfigSource: state.mostRecentConfigSource,
    }), ({ viewConfig: nextViewConfig, mostRecentConfigSource }) => {
        if (onConfigChange && nextViewConfig && mostRecentConfigSource === 'internal') {
            onConfigChange(nextViewConfig);
        }
    }, { equalityFn: shallow }), [viewConfigStoreApi, onConfigChange]);
    useEffect(() => {
        if (linkID !== null) {
            const ws = new WebSocket(websocketEndpoint, ['Authorization', authToken, linkID]);
            ws.addEventListener('open', (event) => {
                log.log('Open', event);
                setSocketOpen(true);
            });
            ws.addEventListener('connecting', (event) => {
                log.log('Connecting', event);
                setSocketOpen(false);
            });
            ws.addEventListener('error', (event) => {
                log.log('Error', event);
            });
            ws.addEventListener('close', (event) => {
                log.log('Close', event);
            });
            ws.addEventListener('message', (event) => {
                log.log('Message', event);
                const eventData = event.data;
                if (eventData.includes(';')) {
                    if (eventData.split(';')[0] === id) {
                        log.log('Message from ourselves');
                    }
                    else {
                        log.log('Message from server ');
                        if (sync) {
                            setConfig({
                                ...JSON.parse(decodeURI(atob(eventData.split(';')[1]))),
                                uid: `id${Math.floor(Math.random() * 1000)}`,
                            });
                        }
                    }
                }
            });
            connection.current = ws;
            return () => ws.close();
        }
        // No-op when websocket was not constructed.
        return () => { };
    }, [viewConfigStoreApi, socketOpen, linkID, sync, authToken, websocketEndpoint]);
    return (_jsx(_Fragment, { children: _jsxs("span", { children: [_jsxs("p", { style: { textAlign: 'justify' }, children: ["To join the same session navigate to ", _jsx("a", { href: "https://vitessce.link", children: "https://vitessce.link" }), " and enter the ", _jsx("b", { children: "Link ID" }), " displayed here in the view. The session is synced as long as the ", _jsx("b", { children: "Link Active" }), " Checkbox is activated."] }), _jsxs(Grid, { container: true, direction: "row", sx: { gridGap: '10px' }, children: [_jsx(Grid, { size: 5, sx: { whiteSpace: 'nowrap' }, children: _jsxs("p", { style: { fontSize: '25px' }, children: ["Link ID:\u00A0\u00A0", _jsx("b", { children: linkID })] }) }), _jsxs(Grid, { size: 5, sx: { fontSize: '25px', whiteSpace: 'nowrap' }, children: ["Link Active: ", _jsx(Checkbox, { sx: { marginTop: '-2px', marginLeft: '-10px' }, color: "primary", checked: sync, onChange: e => setSync(e.target.checked) })] })] })] }) }));
}
//# sourceMappingURL=LinkController.js.map